import FilterDropDown from 'components/FilterDropDown';
import {useTranslation} from 'react-i18next';
import {useHistory, useParams, Link} from 'react-router-dom';
import Styles from '../job-board-list/internal-job-list.module.css';
import JobBoardMenu from 'components/JobboradMenu';
import MapIcon from 'images/svg/mapIcon.svg';
import classNames from './view-application.module.css';
import downloadIcon from 'images/svg/Icon feather-download.svg';
import {Modal} from 'react-bootstrap';
import {useEffect, useState} from 'react';
import {downloadFileFromData, until} from 'helpers/helpers';
import reactQueryKeys from 'helpers/reactQueryKeys';
import {useQueryClient} from 'react-query';
import toastService from 'components/Toasts/toast-service';
import {downloadAPI, getAPI, postAPI} from 'data.api';
import JobBoardMenuMobileView from 'components/JobboradMenu/job-board-menu-mobile-view';
import {appliedJob, downloadResume, employeeCancelAPplication} from 'api_urls';

const ViewApplication = () => {
  const {t} = useTranslation();
  const history = useHistory();
  const {postId} = useParams();
  const queryClient = useQueryClient();
  const [applicationDetails, setapplicationDetails] = useState<any>();
  const [questionnaire_data, setquestionnaire_data] = useState<any>([]);
  const [settings, setsettings] = useState<any>([]);
  const historyState = history?.location?.state?.ViewJob || '';
  const [cancelApplication, setcancelApplication] = useState(false);
  const [isAPILoading, setisAPILoading] = useState(false);
  const [comment, setcomment] = useState(null);

  async function handleRedirect(type) {
    if (type === 'back')
      history.push({
        pathname: `/jobboard/applied`,
      });
  }

  useEffect(() => {
    getViewApplicationDetails();
  }, []);

  async function getViewApplicationDetails() {
    if (historyState?.position_number) {
      const query = `${appliedJob}${historyState?.position_number}`;
      setisAPILoading(true);
      const [err, res] = await until(getAPI(query));
      setisAPILoading(false);
      if (err) {
        toastService.error({msg: err.message});
        return console.error(err);
      }
      if (res) {
        setapplicationDetails(res?.data);
        if (res?.data) {
          const endPoint = `jobs/${historyState?.position_number}/get-apply-job-form`;
          setisAPILoading(true);
          const [err, data] = await until(getAPI(endPoint));
          setisAPILoading(false);
          if (err) {
            toastService.error({msg: err.message});
            return console.error(err);
          }
          if (data?.success) {
            setsettings(data?.data?.employee_settings?.sections);
            setquestionnaire_data(data?.data?.questionnaire_data);
          }
        }
      }
    }
  }

  async function onsubmit() {
    setisAPILoading(true);
    const [err, res] = await until(
      postAPI(
        {
          position_number: historyState?.position_number,
          cancelled_message: comment || '',
        },
        employeeCancelAPplication,
      ),
    );
    setisAPILoading(false);
    if (err) {
      toastService.error({msg: err.message});
      return console.error(err);
    }
    if (res) {
      setcancelApplication(false);
      queryClient.invalidateQueries(reactQueryKeys.ALL_APPLIED_LIST);
      history.push({
        pathname: `/jobboard/applied`,
      });
      return toastService.success({msg: res.message});
    }
  }

  async function downloadResumeFile(resume_path) {
    if (resume_path) {
      const [err, data] = await until(downloadAPI(downloadResume));
      if (err) {
        console.error(err);
        return toastService.show({
          msg: t('Resume not Available For the Application.'),
        });
      }
      if (data) {
        downloadFileFromData(
          data,
          resume_path?.split('/')[resume_path?.split('/')?.length - 1],
        );
        toastService.success({
          msg: t('View_application_Resume downloaded successfully'),
        });
      }
    }
  }
  return (
    <>
      <div>
        <FilterDropDown
          dropdown={false}
          module={'view-application'}
          viewJob={
            historyState?.hiring_request
              ? {
                  ...historyState?.hiring_request,
                  role: historyState?.job_role,
                  created_at:
                    applicationDetails?.application?.created_at ||
                    historyState?.created_at,
                }
              : {
                  ...historyState,
                  created_at: applicationDetails?.application?.created_at
                    ? applicationDetails?.application?.created_at
                    : historyState?.created_at,
                }
          }
        />
      </div>
      <div className={` ${classNames['internal-job-container']}`}>
        <div className={Styles['internal-job-sub-container']}>
          <div className={Styles['internal-job-info-container']}>
            <div className={Styles['internal-job-info']}>
              <JobBoardMenu active={'application'} />
            </div>
          </div>{' '}
          <div
            className={`awl-custom-scroll ${classNames['job-board-list-container']}`}
          >
            {historyState?.position_number ? (
              <div>
                <label className={classNames['applied-location-text']}>
                  {t('View_Application_Selected Job Location')}
                </label>
                <div className={classNames['location-text']}>
                  <img className={classNames['map-icon']} src={MapIcon}></img>
                  <span className={classNames['location-value']}>
                    {applicationDetails?.preferred_location?.name || ''}
                  </span>
                </div>
                <div className={classNames['upload-resume-container']}>
                  <div className={classNames['upload-resume-text']}>
                    {t('View_Application_Uploaded Resume')}
                  </div>
                  {applicationDetails?.resume_path ? (
                    <div className={classNames['resume-file']}>
                      <div className={classNames['resume-file-name']}>
                        <Link download className={classNames['global-color']}>
                          {
                            applicationDetails?.resume_path?.split('/')[
                              applicationDetails?.resume_path?.split('/')
                                ?.length - 1
                            ]
                          }
                        </Link>
                      </div>
                      <div>
                        <img
                          className={classNames['download-icon']}
                          src={downloadIcon}
                          onClick={() =>
                            downloadResumeFile(applicationDetails?.resume_path)
                          }
                        ></img>
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}
                  {applicationDetails ? (
                    <div>
                      {(settings || []).map((s) => {
                        if (
                          s?.category_name == 'other_information' &&
                          applicationDetails['other_information']
                        ) {
                          return (
                            <div key={s?.category_title}>
                              <div className={classNames['view-job-category']}>
                                {s?.category_title}
                              </div>
                              {(s?.attributes || []).map((a) => {
                                return (
                                  <div key={a?.name}>
                                    <div className={classNames['questions']}>
                                      {a.label}
                                    </div>
                                    <div>
                                      <p className={classNames['answer']}>
                                        {applicationDetails[s?.category_name][
                                          a?.name
                                        ]
                                          ? applicationDetails[
                                              s?.category_name
                                            ][a?.name] == 1
                                            ? t('Yes')
                                            : applicationDetails[
                                                s?.category_name
                                              ][a?.name] == 0 ||
                                              !applicationDetails[
                                                s?.category_name
                                              ][a?.name]
                                            ? t('No')
                                            : applicationDetails[
                                                s?.category_name
                                              ][a?.name]
                                          : ''}
                                      </p>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          );
                        } else if (
                          applicationDetails['extra_category_values'] &&
                          applicationDetails['extra_category_values'][
                            s?.category_name
                          ]
                        ) {
                          return (
                            <div key={s?.category_title}>
                              <div className={classNames['view-job-category']}>
                                {s?.category_title}
                              </div>
                              {(s?.attributes || []).map((a) => {
                                return (
                                  <div key={a?.name}>
                                    <div className={classNames['questions']}>
                                      {a.label}
                                    </div>
                                    <div>
                                      <p className={classNames['answer']}>
                                        {applicationDetails[
                                          'extra_category_values'
                                        ][s?.category_name][a?.name]
                                          ? applicationDetails[
                                              'extra_category_values'
                                            ][s?.category_name][a?.name] == 1
                                            ? t('Yes')
                                            : applicationDetails[
                                                'extra_category_values'
                                              ][s?.category_name][a?.name] == 0
                                            ? t('No')
                                            : applicationDetails[
                                                'extra_category_values'
                                              ][s?.category_name][a?.name]
                                          : ''}
                                      </p>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          );
                        } else {
                          return <></>;
                        }
                      })}
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
                <div className={classNames['upload-resume-container']}>
                  <div className={classNames['upload-resume-text']}>
                    {t('View_application_Details')}
                  </div>
                  {applicationDetails &&
                  applicationDetails['questionnaire_response']?.length ? (
                    <div>
                      {(questionnaire_data || []).map((s) => {
                        return (
                          <div key={s?.question}>
                            <div className={classNames['questions']}>
                              {s?.question}
                            </div>
                            <div>
                              {typeof (
                                applicationDetails['questionnaire_response'] ||
                                []
                              ).find((q) => {
                                return q?.question_id === s?.id;
                              })?.value == 'string' ||
                              typeof (
                                applicationDetails['questionnaire_response'] ||
                                []
                              ).find((q) => {
                                return q?.question_id === s?.id;
                              })?.value == 'boolean' ? (
                                <p className={classNames['answer']}>
                                  {(
                                    applicationDetails[
                                      'questionnaire_response'
                                    ] || []
                                  ).find((q) => {
                                    return q?.question_id === s?.id;
                                  })?.value == 1
                                    ? t('Yes')
                                    : (
                                        applicationDetails[
                                          'questionnaire_response'
                                        ] || []
                                      ).find((q) => {
                                        return q?.question_id === s?.id;
                                      })?.value == 0
                                    ? t('No')
                                    : (
                                        applicationDetails[
                                          'questionnaire_response'
                                        ] || []
                                      ).find((q) => {
                                        return q?.question_id === s?.id;
                                      })?.value}
                                </p>
                              ) : (
                                <p className={classNames['answer']}>
                                  {(
                                    (
                                      applicationDetails[
                                        'questionnaire_response'
                                      ] || []
                                    ).find((q) => {
                                      return q?.question_id === s?.id;
                                    })?.value || []
                                  ).map((f) => {
                                    return f?.file_name;
                                  })}
                                </p>
                              )}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
                {!isAPILoading ? (
                  <div className={classNames['view-job-btns']}>
                    <button
                      className={`${classNames['view-btn']} ${classNames['apply-submit-btn']}`}
                      onClick={() =>
                        !applicationDetails?.application?.is_cancelled
                          ? setcancelApplication(true)
                          : ''
                      }
                      disabled={applicationDetails?.application?.is_cancelled}
                    >
                      {t('Applications_Cancel Application')}
                    </button>
                    <button
                      className={`ml-2 ${classNames['apply-btn']} ${classNames['apply-submit-btn']}`}
                      onClick={() => handleRedirect('back')}
                    >
                      {t('View_application_Back')}
                    </button>
                  </div>
                ) : (
                  <></>
                )}
              </div>
            ) : (
              <>
                {' '}
                <div className={classNames['records-not-found']}>
                  {t('Records Not Found')}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      <div className={Styles['menu-item-mv']}>
        <JobBoardMenuMobileView active={'application'} />
      </div>
      <Modal
        className="awl-modal"
        show={cancelApplication}
        onHide={() => {
          setcancelApplication(false);
        }}
        size={'md' as any}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title> {t('Applications_Cancel Application')} </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0 pr-1 awl-custom-scroll">
          <div className={classNames['cancel-modal']}>
            {t(
              'Cancel_Application_Are you sure you want to cancel the application?',
            )}
          </div>
          <div className="mb-2">
            <textarea
              className="awl-form-control"
              placeholder={t('Enter')}
              name={'comment'}
              value={comment}
              onChange={(e) => {
                setcomment(e.target.value);
              }}
            />
          </div>
          <div className={classNames['cancel-modal-btns']}>
            <button
              className={`mr-2 ${Styles['view-btn']}`}
              onClick={() => setcancelApplication(false)}
            >
              {t('No')}
            </button>
            <button
              className={Styles['apply-btn']}
              disabled={isAPILoading}
              onClick={() => onsubmit()}
            >
              {t('Yes')}
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ViewApplication;
